import styled from 'styled-components';
import { colors } from '../colors';

interface cardBodyProps {
	projectNavigation?: boolean;
	padding?: string;
	margin?: string;
	docCardImg?: boolean;
	paddingBottom?: string;
	filterDuplicatesList?: boolean;
	projectIndividualScreenBlock?: boolean;
	projectIndividualCards?: boolean;
	projectIndividualCardsActive?: boolean;
	maxHeight?: string;
}

const CardBody = styled.div<cardBodyProps>`
	padding: 12px 15px 0;
	margin: ${({ margin }) => margin}!important;
	padding: ${({ padding }) => padding}!important;
	max-height: ${({ maxHeight }) => maxHeight}!important;
	${({ projectNavigation }) =>
		projectNavigation &&
		`background:transparent;
		padding: 0 24px 0;
		display: inline-block;
		width:100%;
		margin-bottom:0!important;
	`}
	${({ docCardImg }) =>
		docCardImg &&
		`margin-bottom: 10px;
		img{
			width: 100%;
			max-height: 250px;
			object-fit: contain;
			overflow: hidden;
		}
	`}	
	${({ filterDuplicatesList }) =>
		filterDuplicatesList &&
		`overflow: hidden;
		overflow-y: auto;
		max-height: calc(100vh - 490px);
		padding: 0;
		img{
			object-fit: fill!important;
		}
	`}
	${({ projectIndividualScreenBlock }) =>
		projectIndividualScreenBlock &&
		`float:left;
		width:100%;
		padding:16px 0 4px 0!important;
	`}
	${({ projectIndividualCards }) =>
		projectIndividualCards &&
		`padding: 8px!important;
		border: 1px solid ${colors.GreyE1};
		box-sizing: border-box;
		border-radius: 2px;
		img{
			width: 116px;
			height: 106px;
			object-fit: fill;
		}
	`}
	${({ projectIndividualCardsActive }) =>
		projectIndividualCardsActive &&
		`border: 1px solid ${colors.BlueDark};
		box-shadow: 0px 0px 5px rgba(33, 121, 202, 0.7);
	`}
	.card-info-block {
		margin-bottom: 16px;
		.card-label {
			font-size: 13px;
			line-height: 19px;
			color: #a0b1bf;
		}
		.card-data {
			font-size: 13px;
			line-height: 19px;
			color: #000000;
			&.h2 {
				font-weight: bold;
			}
		}
		img{
			width:20px;
			margin-right:5px;
		}

	}
	.StripeCheckout {
		display: block !important;
    	margin: 0 auto 15px;
	}
`;

export default CardBody;
